import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

const BASE_API_URL = '';

@Injectable({
  providedIn: 'root'
})
export class AllocationIpService {
  constructor(private http: HttpClient) {

  }
  getippoolnamebyid(poolId){
    const get_url = BASE_API_URL + 'ippool/getEntityByIdForAllocation/'+ poolId;
    return this.http.get<any>(get_url)
  }

  getSubscriberPurchasedIp(custId:number): Observable<any> {
    const get_url = BASE_API_URL + 'subscriber/getSubscriberPurchasedIp/'+custId;
    return this.http.get<any>(get_url,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  saveAllocationIp(data:any): Observable<any> {
    const post_url = BASE_API_URL + 'subscriber/allocateIp';
    return this.http.post<any>(post_url,data,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

}
